module.exports = __webpack_public_path__ + "img/emoji_36.d5993a4f.png";